import { template } from 'lodash';
import {
  FieldTypes,
  BelongsCreatedByRefField,
  systemDateField,
  exportHideField,
} from 'drapcode-constant';
const { createdBy, isDeleted, uuid } = FieldTypes;
//TODO: DOCUSIGN Need refactoring and try to use drapcode-constant
export const getTemplateFormCollectionFieldOptions = (templateCollection, collections) => {
  let options = [];
  if (templateCollection) {
    const { fields } = templateCollection;
    const nestedFields = getInnerFieldOptions(fields, collections);
    const fieldOptions = fields
      ? fields
          .filter(
            (e) =>
              ![
                ...BelongsCreatedByRefField,
                ...exportHideField,
                ...systemDateField,
                isDeleted.id,
                uuid.id,
              ].includes(e.type),
          )
          .map((item) => {
            return {
              fieldName: item.fieldName,
              fieldTitle: item.fieldTitle.en,
            };
          })
      : [];
    options = [...fieldOptions, ...nestedFields];
    if (templateCollection.collectionName === 'user') {
      options.push({
        fieldName: 'siteUrl}}/reset-password/?token={{autorizationToken',
        fieldTitle: 'Reset Password Link',
      });
      options.push({
        fieldName: 'siteUrl}}/auth-with-email/?token={{autorizationToken',
        fieldTitle: 'Magic Login Link',
      });
    }
  }

  return options;
};

//TODO
export const getInnerFieldOptions = (fields, collections) => {
  let nestedFields = [];
  const referenceFields = fields
    ? fields.filter((field) => BelongsCreatedByRefField.includes(field.type))
    : [];
  if (referenceFields.length > 0) {
    referenceFields.map((field) => {
      if (field.type === createdBy.id && !field.refCollection) {
        field.refCollection = {
          collectionName: 'user',
          collectionField: 'userName',
          displayType: 'dropdown',
        };
      }
      let { collectionName } = field.refCollection;
      let refFields = [];

      const refrenceCollection = collections
        ? collections.find((e) => e.collectionName === collectionName)
        : null;
      refFields =
        refrenceCollection && refrenceCollection.fields
          ? refrenceCollection.fields
              .filter(
                (e) =>
                  ![
                    ...BelongsCreatedByRefField,
                    ...exportHideField,
                    ...systemDateField,
                    isDeleted.id,
                    uuid.id,
                  ].includes(e.type),
              )
              .map((nestedField) => {
                return {
                  fieldName: field.fieldName + '.' + nestedField.fieldName,
                  fieldTitle: field.fieldTitle.en + ':' + nestedField.fieldTitle.en,
                };
              })
          : [];
      nestedFields = [...nestedFields, ...refFields];
    });
  }
  return nestedFields;
};
